import {
  type UserOrderResponseWithFlagsSubOrdersInner,
  type UserSubOrderV2,
  UserSubOrderV2EnrichedStatusEnum,
} from '@redteclab/api/clients/bully'

import { SELLER_ID_SAE } from './SELLER_ID_SAE'
import {
  userSubOrderAccessorIsCancellationRequested,
  userSubOrderAccessorIsNow,
} from './userSubOrderAccessor'
import { userSubOrderAccessorIsSelfService } from './userSubOrderAccessorIsSelfService'
import { userSubOrderAccessorIsSubOrderReturnable } from './userSubOrderAccessorIsSubOrderReturnable'

type SubOrderAfterSalesSelfServiceAvailability =
  'disabled' | 'enabled' | 'hidden'

export const subOrderStatusAccessorGetAfterSalesSelfServiceAvailability = (
  subOrder: UserOrderResponseWithFlagsSubOrdersInner | UserSubOrderV2,
  isParcelLabDelivered: boolean,
): SubOrderAfterSalesSelfServiceAvailability => {
  const isShopApothekeNonNowOrder =
    subOrder.sellerId === SELLER_ID_SAE && !userSubOrderAccessorIsNow(subOrder)
  const isReturnable = userSubOrderAccessorIsSubOrderReturnable(subOrder)
  const isClaimable = userSubOrderAccessorIsSelfService(subOrder)

  if (userSubOrderAccessorIsCancellationRequested(subOrder)) {
    return 'hidden'
  }

  const hasAvailableAfterSalesAction = isReturnable || isClaimable

  switch (subOrder.enrichedStatus) {
    case UserSubOrderV2EnrichedStatusEnum.Canceled:
    case UserSubOrderV2EnrichedStatusEnum.CancelRequested:
    case UserSubOrderV2EnrichedStatusEnum.Closed:
    case UserSubOrderV2EnrichedStatusEnum.Completed:
    case UserSubOrderV2EnrichedStatusEnum.New:
    case UserSubOrderV2EnrichedStatusEnum.Processing:
    case UserSubOrderV2EnrichedStatusEnum.WaitingForPrepayment: {
      return 'hidden'
    }
    case UserSubOrderV2EnrichedStatusEnum.Dispatched:
    case UserSubOrderV2EnrichedStatusEnum.ReadyForPickup: {
      if (isShopApothekeNonNowOrder && !hasAvailableAfterSalesAction) {
        return 'hidden'
      }

      return !isShopApothekeNonNowOrder || isParcelLabDelivered
        ? 'enabled'
        : 'disabled'
    }
    default: {
      return 'hidden'
    }
  }
}
